import { npcRotationTexturePathRotations } from "./asset-mapper.js";

/** South-facing NPC portrait for Case File HTML. */
export function npcSouthPortraitImgHtml(
  npcId: string,
  opts?: { sizePx?: number; alt?: string; className?: string }
): string {
  const size = opts?.sizePx ?? 48;
  const src = npcRotationTexturePathRotations(npcId, "south");
  const alt = opts?.alt ?? "";
  const cls = opts?.className ?? "npc-portrait-thumb";
  return `<img class="${cls}" src="${src}" width="${size}" height="${size}" alt="${alt}" loading="lazy" />`;
}
